<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb :name="staffLabel" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="mr-2 mt-2 ">
            <div class="row">
<!--              <div class="col-md-6 col-6">-->
<!--                <div class="d-flex align-items-center">-->
<!--                  <button-->
<!--                      type="button"-->
<!--                      class="btn btn-gradient-warning"-->
<!--                      @click="$router.push({ name: 'merchant-staff-permission' })"-->
<!--                  >-->
<!--                    <span class="text-nowrap">Permissions</span>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-gradient-danger"
                      @click="$router.push({ name: 'merchant-staff-add' })"
                  >
                    <span class="text-nowrap">Add {{ $store.getters.isPayfacMerchant ? 'Sub Merchant' : 'Staff' }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              url="v1/get-merchant-staff"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="mutedData"
              customClass="table-hover-animation"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  computed: {
    staffLabel() {
      return this.$store.getters.isPayfacMerchant ? 'Sub Merchants' : 'Merchant Staff'
    },
    breadcrumb() {
      return [
        {name: 'App'},
        {name: this.staffLabel},
      ]
    },
  },
  data() {
    return {
      tableHeaderValues: [
        {
          title: 'Email',
          valueKey: 'email',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<div class="badge badge-glow badge-light-primary">${value}</div>`


            return html


          }
        },
        {
          title: 'Phone',
          valueKey: 'phone_number',
        },
        {
          title: 'First Name',
          valueKey: 'first_name',
        },
        {
          title: 'Last Name',
          valueKey: 'last_name',
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 0)
              html = `<div class="badge badge-pill  badge-glow badge-warning">Pending</div>`
            else if(value == 1)
              html = `<div class="badge badge-pill  badge-glow badge-success">Active</div>`
            else if(value == 2)
              html = `<div class="badge badge-pill  badge-glow badge-danger">Inactive</div>`
            else
              html = `<div class="badge badge-pill  badge-glow badge-info">Suspended</div>`


            return html


          }
        },
      ],
      actions: [
        {
          title: 'Update',
          cta: (row) => {
            this.$store.commit('setUpdateStaffData', row);
            this.$router.push({name:'merchant-staff-update'})
          }
        },
        {
          title: 'Permissions',
          class: 'btn-gradient-warning ml-1',
          cta: (row) => {
            this.$store.commit('setUpdateStaffData', row);
            this.$router.push({name:'merchant-staff-permission'})
          }
        },
      ],
      mutedData: [],
    }
  },
  methods: {

  }
}
</script>

